import module from 'finanzas/module.js'

function CuentasBancarias ($api, $export) {
  this.existecuenta = function (no_cuenta) {
    return $api.get('/kendu/finanzas/bancosCuentas/existeCuenta', {
      no_cuenta: no_cuenta,
    })
  }

  this.obtenerClientes = function () {
    return $api.get('/kendu/finanzas/bancosCuentas/clientesCuentasBancarias')
  }

  this.obtenerCuentasBancarias = function (ID_Cliente) {
    return $api.get('/kendu/finanzas/bancosCuentas/traerCuentasBancarias', {ID_Cliente})
  }

  this.agregarCuentasBancarias = function (ID_Empleado, data) {
    return $api.post('/kendu/finanzas/bancosCuentas/agregarCuentasBancarias', {
      ID_Empleado: ID_Empleado,
      data: data,
    })
  }

  this.obtenerCuentaBancaria = function (ID_Cuenta) {
    return $api.get('/kendu/finanzas/bancosCuentas/obtenerCuentaBancaria', {
      ID_Cuenta: ID_Cuenta,
    })
  }

  this.editarCuentasBancarias = function (id_Cuenta, data) {
    return $api.post('/kendu/finanzas/bancosCuentas/editarCuentaBancaria', {
      ID_Cuenta: id_Cuenta,
      data: data,
    })
  }

  this.exportartodascuentasbancarias = function () {
    return $api.get('/kendu/finanzas/bancosCuentas/exportartodascuentasbancarias')
      .then(function (data) {
        $export.excel('Cuentas Bancarias', [{
          name: 'Clientes',
          details: [],
          columns: [
            {label: 'Cliente', format: {width: 50}},
            {label: 'Banco', format: {width: 10}},
            {label: 'Número de Cuenta', format: {width: 20}},
            {label: 'CLABE', format: {width: 20}},
            {label: 'Moneda', format: {width: 8, align: 'center'}},
            {label: 'Número de Contrato', format: {width: 20}},
            {label: 'Cuenta Contable', format: {width: 20}},
            {label: 'C. Contable Complementaria', format: {width: 20}},
            {label: 'Kardex Bancario', format: {width: 25}},
            {label: 'Representante Legal', format: {width: 25}},
            {label: 'Contrato Bancario', format: {width: 20}},
            {label: 'Estatus', format: {width: 10, align: 'center'}},
          ],
          options: {
            logo: {
              filename: '/api/export/images/FAN-logo.png',
              title: 'FAN Consultores',
              cell: 'A1',
            },
            show_grid: false,
            fixed_column: 'A8',
          },
          data: data,
        }])

        return data
      })
  }

  this.exportarCuentasBancarias = function (ID_Cliente) {
    return $api.get('/kendu/finanzas/bancosCuentas/exportarCuentasBancarias', {
      ID_Cliente: ID_Cliente,
    }).then(function (data) {
      $export.excel('exportar', [{
        name: 'Departamento',
        details: [],
        columns: [
          {label: 'Banco', format: {width: 10}},
          {label: 'Número de Cuenta', format: {width: 20}},
          {label: 'CLABE', format: {width: 20}},
          {label: 'Moneda', format: {width: 8, align: 'center'}},
          {label: 'Número de Contrato', format: {width: 20}},
          {label: 'Cuenta Contable', format: {width: 20}},
          {label: 'C. Contable Complementaria', format: {width: 20}},
          {label: 'Kardex Bancario', format: {width: 25}},
          {label: 'Representante Legal', format: {width: 25}},
          {label: 'Firmante 1', format: {width: 20}},
          {label: 'Tipo', format: {width: 20}},
          {label: 'Firmante 2', format: {width: 20}},
          {label: 'Tipo', format: {width: 20}},
          {label: 'Firmante 3', format: {width: 20}},
          {label: 'Tipo', format: {width: 20}},
          {label: 'Firmante 4', format: {width: 20}},
          {label: 'Tipo', format: {width: 20}},
          {label: 'Contrato Bancario', format: {width: 20}},
          {label: 'Estatus', format: {width: 10, align: 'center'}},
        ],
        options: {
          logo: {
            filename: '/api/export/images/FAN-logo.png',
            title: 'FAN Consultores',
            cell: 'A1',
          },
          show_grid: false,
          fixed_column: 'A8',
        },
        data: data,
      }])

      return data
    })
  }
}

module.service('CuentasBancarias', CuentasBancarias)



// WEBPACK FOOTER //
// ./src/finanzas/services/CuentasBancarias.js